// extracted by mini-css-extract-plugin
export default {"rootContainer":"style_rootContainer__xVI7j","primaryContainer":"style_primaryContainer__2sKIR"};